export interface IProfileDetails {
  nameBorker: string
  branchCode: string
}

export const profileDetailsInitValues: IProfileDetails = {
  nameBorker: '',
  branchCode: '',
}
